import HeaderGeneric from "../../../components/generic/headerGeneric";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import themeBase from "../../../utils/theme/themeBase";
import { CommandBar, DatePicker, IComboBox, ICommandBarItemProps, Label, PrimaryButton } from "@fluentui/react";
import TokenService from "../../../services/tokenService";
import { useCallback, useEffect, useRef, useState } from "react";
import { urlTelerik } from "../../../services/http-common";
import AuthService from "../../../services/authService";
import { keyAccess } from "../../../utils/helpers/helpers";
import { ETelerikViewmode } from "../../../components/generic/baseTelerik";
import { onFormatDate } from "../../../utils/helpers/dateHelpers";
import { ComboBoxIDS } from "../../../components/generic/ComboBoxIDS";
import personaServicio from "../../../services/persona/personaServicio";
import ListaVerificacionService from "../../../services/listaVerificacionService";
import { useComboEquipos } from "../../../hooks/combosHooks/useComboEquipos";
import { useComboModelos } from "../../../hooks/combosHooks/useComboModelos";
import IconHelper from "../../../utils/helpers/iconHelper";
import { IExportarReporte, IParametro } from "../../../Interfaces/base/IBase";
import reporteServicio from "../../../services/reporteService";

let title: string = "Reporte Histórico Checklist";
let subTitle: string = "Reporte Historico Checklist";
let subTitle2: string = "";
let reportName = "ChecklistReporteHistorico.trdx";

interface IComboBoxOptionPersonalizado {
  key: string;
  text: string;
  puesto?: string;
}
export interface IReporteHistoricoChecklist {
  FechaInicio: Date | null;
  FechaFin: Date | null;
  SupervisorId: string | null;
  EstadoId: string | null;
  EquipoModeloId: string | null;
  EquipoId: string | null;
}

export const ReporteHistoricoChecklist = () => {
  const urlTelerikR = `${urlTelerik}/reports`;
  let t = TokenService.getToken();
  let viewerRef;
  // const viewerRef = useRef();
  let viewMode = ETelerikViewmode.INTERACTIVE;
  const comboBoxRefSupervisores = useRef<IComboBox>(null);
  const comboBoxRefEstado = useRef<IComboBox>(null);

  const [search, setSearch] = useState("");
  const [searchEstado, setSearchEstado] = useState("");

  const controllerRef = useRef<AbortController>(new AbortController());
  const [SupervisoresCombo, setSupervisoresCombo] = useState<
    IComboBoxOptionPersonalizado[]
  >([]);
  const [estados, setEstados] = useState<IComboBoxOptionPersonalizado[]>([]);
  const {
    dataCombo,
    _onkeyUpSearchEquipo,
    comboBoxRefEquipoModelo,
    onChangeModelo,
    onClickCamboEquipo,
  } = useComboEquipos();

  const {
    dataComboModelos,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
  } = useComboModelos();

  const [filtro, setfiltro] = useState<IReporteHistoricoChecklist>({
    FechaInicio: new Date(),
    FechaFin: new Date(),
    SupervisorId: null,
    EstadoId: null,
    EquipoModeloId: null,
    EquipoId: null,
  });

  const [key, setKey] = useState(0);

  // useEffect(() => {
  //   var { viewerObject } =
  //     viewerRef.current != null ? viewerRef.current : viewerObject;
  //   viewerObject.authenticationToken(TokenService.getToken());
  //   viewerObject.reportSource({
  //     report: "ChecklistReporteHistorico.trdx",
  //     parameters: filtro,
  //   });
  // }, [filtro]);
  useEffect(() => {
    fetch(`${urlTelerikR}/version`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TokenService.getToken()}`,
      },
    })
      .then((response) => {
        //alert("Error telerick ...");
        //console.log("Código de estado:", response.status);
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem(keyAccess);
          AuthService.removeToken();
          window.location.assign("/login");
        }
        if (response.ok) {
          response.json().then((data) => {
            console.log("Datos de la respuesta:", data);
          });
        } else {
          console.error("Error al realizar la solicitud:", response.statusText);
        }
      })
      .catch((error) => {
        console.error("Error de red:", error);
      });
  }, []);

  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        setfiltro({ ...filtro, FechaInicio: date });
        setKey(prevKey => prevKey + 1);
        // setFilter({ ...filter, fechaInicio: _formatDate(date, ",") });
        break;
      case "fin":
        // setfiltro({ ...filtro, FechaFin: _formatDate(date, ",") });
        setfiltro({ ...filtro, FechaFin: date });
        setKey(prevKey => prevKey + 1);

        break;
      default:
        break;
    }
  };

  const onChangeComboBox = (e, o, text) => {
    if (e !== undefined) {
      switch (text) {
        // case "actividad":
        //   filtro({ ...filtro, actividadId: o.key });
        //   break;
        case "equipo":
          if (o?.key) {
            setfiltro({ ...filtro, EquipoId: o.key });
            setKey(prevKey => prevKey + 1);
          }
          break;
        case "supervisor":
          if (o?.key) {
            setfiltro({ ...filtro, SupervisorId: o.key });
            setKey(prevKey => prevKey + 1);
          }
          break;
        case "estado":
          if (o?.key) {
            setfiltro({ ...filtro, EstadoId: o.key });
            setKey(prevKey => prevKey + 1);
          }
          break;
        case "modeloEquipo":
          if (o?.key) {
            setfiltro({ ...filtro, EquipoModeloId: o.key });
            setKey(prevKey => prevKey + 1);
          }
          break;
        default:
          break;
      }
    }
  };

  const _onkeyUpSearchSupervisores = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefSupervisores.current?.focus(false);
      setSearch("");
    } else {
      _openOptionSupervisores();
      let { value } = event?.target as HTMLInputElement;
      setSearch(value);
    }
  };

  const _onkeyUpSearchEstados = (event: React.KeyboardEvent<IComboBox>) => {
    if (event.code === "Escape") {
      comboBoxRefEstado.current?.focus(false);
      setSearchEstado("");
    } else {
      _openOptionEstados();
      let { value } = event?.target as HTMLInputElement;
      setSearchEstado(value);
    }
  };
  const _openOptionSupervisores = useCallback(
    () => comboBoxRefSupervisores.current?.focus(true),
    []
  );

  const _openOptionEstados = useCallback(
    () => comboBoxRefEstado.current?.focus(true),
    []
  );
  const onClickComboSupevisores = () =>
    comboBoxRefSupervisores.current?.focus(true);

  const onClickComboEstados = () => comboBoxRefEstado.current?.focus(true);

  const getComboSupervisores = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;

    personaServicio
      .getSupervisoresCombo(search, newController)
      .then((res) => {
        if (res.status === 200) {
          setSupervisoresCombo(res.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const transformarParametros = (parametros: IReporteHistoricoChecklist): IParametro[] => {
    return Object.entries(parametros).map(([key, value]) => ({
      Key: key,
      Value: value,
    }));
  };

  function descargarReporte(extension: string) {
    const reporteExportar: IExportarReporte = {
      report: reportName,
      Extension: extension
    }
    if (filtro !== undefined) {
      if (filtro !== null) {
        console.log("----Parametros-----")
        console.log(filtro)
        //reporteExportar.Parametros=parametros;
        reporteExportar.Parametros = transformarParametros(filtro);
      }
    }
    reporteServicio.exportaReporte(reporteExportar)
      .then((response) => {
        if (response.status === 200) {
          const dataUrl = response.data;

          // Create a link element
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'reporte'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

          // Simulate a click on the link to trigger the download
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        }
        else {
          console.error("Status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // Función para recargar el componente
  const recargarComponente = () => {
    setfiltro({
      ...filtro,
      FechaInicio: new Date(),
      FechaFin: new Date(),
      SupervisorId: null,
      EstadoId: null,
      EquipoModeloId: null,
      EquipoId: null,
    });
    setKey(prevKey => prevKey + 1);
  };

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      // onClick: (arg) => actualizarTabla(),
      // onClick: () => viewerRef.refreshReport(),
      onClick: recargarComponente,
    }
  ];


  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_PDF,
      onClick: () => {
        descargarReporte("PDF");
      },
    },
    {
      ...IconHelper.ICON_EXCEL,
      onClick: () => {
        descargarReporte("XLSX");
      },
    }
  ];



  const obtenerPuesto = (key: any) => {
    const puestos = SupervisoresCombo?.find((elem) => elem.key === key);
    return puestos ? puestos.puesto : "No Tiene Puesto";
  };
  useEffect(() => {
    getComboSupervisores();
  }, [search]);

  useEffect(() => {
    getComboSupervisores();
  }, [search]);

  const dataEstados = () => {
    ListaVerificacionService.listaEstados()
      .then((res) => {
        setEstados(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    dataEstados();
  }, []);

  useEffect(() => {
    const hideExportButton = () => {
      const exportButton: any = document.querySelector("#trv-main-menu-export-command");
      console.log(exportButton)

      if (exportButton) {
        // console.log(exportButton)
        exportButton.remove();
        // exportButton.style.display = 'none';
        clearInterval(interval);
      }
    };

    // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
    const interval = setInterval(hideExportButton, 1);

    // Limpia el intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, [key, reportName]);

  return (
    <>
      <div
        className="ms-Grid-col ms-sm12 ms-md4 ms-lg4"
        style={{
          paddingTop: "0.5em",
        }}
      >
        <HeaderGeneric
          title={title}
          subTitle={subTitle}
          subTitle2={subTitle2}
          enabledicon={true}
        // sizeTitles={{ first: 24, second: 11, third: 10 }}
        />
      </div>
      <br />
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            width: "25%",
          }}
        >
          <div
            style={{
              margin: "0 10px",
              padding: "0 10px",
              width: "100%",
              border: "solid 1px #d5d5d5",
            }}
          >
            <Label
              style={{
                display: "flex",
                marginBottom: "10px",
                textAlign: "center",
              }}
            >
              Filtros
            </Label>
            {/* <pre>{JSON.stringify(filtro, null, 2)}</pre> */}
            <DatePicker
              label="Fecha Inicio:"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              value={filtro.FechaInicio!}
              onSelectDate={(date?: any) => {
                _onSelectDate(date, "inicio");
              }}
              formatDate={onFormatDate}
            //   maxDate={new Date()}
            />
            <DatePicker
              label="Fecha Fin:"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              value={filtro.FechaFin!}
              onSelectDate={(date?: any) => {
                _onSelectDate(date, "fin");
              }}
              formatDate={onFormatDate}
            //   maxDate={new Date()}
            />

            <ComboBoxIDS
              title="Supervisor:"
              componentRef={comboBoxRefSupervisores}
              selectedKey={filtro.SupervisorId}
              KeyUp={_onkeyUpSearchSupervisores}
              onChange={(e, o) => {
                onChangeComboBox(e, o, "supervisor");
              }}
              onClick={onClickComboSupevisores}
              options={SupervisoresCombo}
              useComboBoxAsMenuWidth={false}
              dropdownWidth={380}
              onRenderOption={(option) => (
                <>
                  {option && (
                    <div>
                      <span>{option?.text}</span>
                      <br />
                      <span
                        style={{
                          paddingBottom: "0.9px",
                          color: "#777",
                          fontSize: "0.7rem",
                        }}
                      >
                        {obtenerPuesto(option?.key)}
                      </span>
                    </div>
                  )}
                </>
              )}
            />

            <ComboBoxIDS
              title="Modelo Equipo:"
              componentRef={comboBoxRefModelos}
              KeyUp={_onkeyUpSearchDispositivo}
              selectedKey={filtro.EquipoModeloId}
              onClick={onClickComboModelos}
              options={dataComboModelos}
              useComboBoxAsMenuWidth={false}
              dropdownWidth={380}
              onRenderOption={(option) => (
                <>
                  {option && (
                    <div>
                      <span>{option?.text}</span>
                    </div>
                  )}
                </>
              )}
              onChange={(e, o) => {
                onChangeComboBox(e, o, "modeloEquipo");
                onChangeModelo(e, o);
              }}
            />

            <ComboBoxIDS
              title="Equipo:"
              componentRef={comboBoxRefEquipoModelo}
              KeyUp={_onkeyUpSearchEquipo}
              selectedKey={filtro.EquipoId}
              onChange={(e, o) => {
                onChangeComboBox(e, o, "equipo");
              }}
              useComboBoxAsMenuWidth={false}
              dropdownWidth={380}
              onClick={onClickCamboEquipo}
              options={dataCombo}
            />

            <ComboBoxIDS
              title="Estado:"
              componentRef={comboBoxRefEstado}
              selectedKey={filtro.EstadoId}
              KeyUp={_onkeyUpSearchEstados}
              onChange={(e, o) => {
                onChangeComboBox(e, o, "estado");
              }}
              onClick={onClickComboEstados}
              options={estados}
            />
          </div>
        </div>
        <div className="ms-Grid-col ms-sm12 ms-lg12">
          <div className="ms-Grid-col ms-sm12 ms-lg12">
            <CommandBar
              items={_items}
              farItems={_farItems}
              styles={themeBase.commadStyles}
            />
          </div>
          <div key={key}>
            <TelerikReportViewer
              // ref={viewerRef}
              ref={el => viewerRef = el}
              serviceUrl={urlTelerikR}
              reportSource={{
                report: reportName,
                parameters: { ...filtro },
                // parameters: { editors: { multiSelect: { parametros } } },
              }}
              viewerContainerStyle={themeBase.telerikStyle}
              parametersAreaVisible={true}
              viewMode={viewMode}
              scaleMode="FIT_PAGE_WIDTH"
              scale={1.0}
              enableAccessibility={false}
              authenticationToken={t}
            />
          </div>
        </div>
        {/* <TelerikReportViewer
          ref={viewerRef}
          serviceUrl={urlTelerikR}
          reportSource={{
            report: "ChecklistReporteHistorico.trdx",
            parameters: { ...filtro },
            // parameters: { editors: { multiSelect: { parametros } } },
          }}
          viewerContainerStyle={themeBase.telerikStyle}
          parametersAreaVisible={true}
          viewMode={viewMode}
          scaleMode="FIT_PAGE_WIDTH"
          scale={1.0}
          enableAccessibility={false}
        /> */}
      </div>
    </>
  );
};
